module.exports = __webpack_public_path__ + "static/media/Monedero.fa12af2b.png";